// src/components/AnalyticsCard.tsx
import React from 'react';

interface AnalyticsCardProps {
  label: string;
  value?: string | number;
}

const AnalyticsCard: React.FC<AnalyticsCardProps> = ({
  label,
  value,
}) => {

  return (
    <div
      className='
        bg-white
        rounded-[24px]
        shadow
        pt-[16px]
        pr-[20px]
        pb-[20px]
        pl-[20px]
        xl:pt-[36px]
        xl:pr-[40px]
        xl:pb-[44px]
        xl:pl-[40px]
        lg:py-[15px]
        lg:px-[25px]
        flex
        flex-col
        gap-4
     


        
      '
    >
      <div className='flex flex-col items-start justify-start'>
      <p className=' text-[10px] md:text-[16px] lg:text-[18px] text-gray-500'>{label}</p>
        <span className=' md:text-[28pxg] lg:text-[32px] font-semibold'>{value}</span>
       
      </div>
    </div>
  );
};

export default AnalyticsCard;
